<template>
  <div class="row">
    <link-button
      class="tc-link-button"
      text="תנאי שימוש"
      @click="openTermsAndConditions"/>
    <link-button
      class="tc-link-button"
      text="ומדיניות פרטיות"
      @click="openPrivacyPolicy" />
  </div>

</template>

<script>
import LinkButton from '@/components/base/LinkButton';
import ExternalPagesActions from '@/mixins/ExternalPagesActions';

export default {
  name: 'TermsAndConditionsLinkButtons',
  components: { LinkButton },
  mixins: [ExternalPagesActions],
};
</script>

<style lang="scss" scoped>
.tc-link-button:first-of-type {
  margin-right: 5px;
}
</style>
